import React, { Component } from 'react';
import 'whatwg-fetch';
import './Footer.css';

class Footer extends Component {
  render() {
    return (
      <div>
        <footer id="footer">
          <div className="inner">
            <div className="split style1">
              <div className="contact">
                <h2>Contact</h2>
                <ul className="contact-icons">
                  <li className="icon fa-home left">(Office) 1240 Riggs St<br />Kennett, MO 63857</li>
                  <li className="icon fa-phone left">(573) 559-1615</li>
                  <li className="icon fa-envelope-o left"><a href="mailto:info@pdfiber.com">info@pdfiber.com</a></li>
                </ul>
                <ul className="icons-bordered">
                  <li><a className="icon fa-facebook" href="https://www.facebook.com/PDFiber/">
                    <span className="label">Facebook</span>
                  </a></li>
                  <li><a className="icon fa-twitter" href="https://twitter.com/PDFiber">
                    <span className="label">Twitter</span>
                  </a></li>
                </ul>
              </div>
            </div>
            <div className="copyright">
              <p>&copy; 2018 PD Fiber, LLC. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js